export const getLocaleFromQuery = () => {
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    return params.get("lng") || "en"; // fallback to English
  }
  return "en";
};

export const getDir = (locale?: string): "ltr" | "rtl" => {
  const rtlLanguages = ["ar", "he", "fa", "ur"];
  const currentLocale = locale || getLocaleFromQuery();
  return rtlLanguages.includes(currentLocale) ? "rtl" : "ltr";
};

